import React, { useEffect, useState } from 'react'
import ExpiryAlertList from '../components/ExpiryAlertList';
import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import ExpiryAlertCRU from '../components/ExpiryAlertCRU';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { deleteExpiryAlertApi, getExpiryAlertApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import { useParams } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { ShowAttachments } from '../../../shared_elements/components';
import { useDispatch, useSelector } from 'react-redux';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import { RoleBaseAccess } from '../../../hoc';
import { getStorage } from '../../../shared_elements/actionCreators';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const ExpiryAlertHD = ({ onRequestSort, sortConfig, item, toggleBulkOps, bulk, handleItemClicked }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    }
    return (
        <TableRow>
            <TableCell className="table-actions-header" sx={{whiteSpace: "nowrap", minWidth: '140px'}}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['D'] }}>
                <Checkbox size='small' sx={{ cursor: 'pointer' }} onChange={(e) => toggleBulkOps(e.target.checked, "bulk", item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /> </PermissionWrapper>Action(s)
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "name"} direction={sortConfig?.field === "name" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("name"); handleItemClicked(`Table Sorting: Name`) }}>Name</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "frequency_to_notify"} direction={sortConfig?.field === "frequency_to_notify" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("frequency_to_notify")(); handleItemClicked(`Table Sorting: Notify Days`) }}>Notify Days</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "module_name"} direction={sortConfig?.field === "module_name" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("module_name")(); handleItemClicked(`Table Sorting: Features`) }}>Features</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '150px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "module_fields"} direction={sortConfig?.field === "module_fields" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("module_fields")(); handleItemClicked(`Table Sorting: Based On Fields`) }}>Based On Fields</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "status"} direction={sortConfig?.field === "status" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("status")(); handleItemClicked(`Table Sorting: Status`) }}>Status</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '150px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "sparta_user_email"} direction={sortConfig?.field === "sparta_user_email" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("sparta_user_email")(); handleItemClicked(`Table Sorting: SPARTA Users`) }}>SPARTA Users</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "non_sparta_user_email"} direction={sortConfig?.field === "non_sparta_user_email" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("non_sparta_user_email")(); handleItemClicked(`Table Sorting: Non SPARTA Users`) }}>Non SPARTA Users</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "description"} direction={sortConfig?.field === "description" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("description")(); handleItemClicked(`Table Sorting: Description`) }}>Description</TableSortLabel>
            </TableCell>
        </TableRow>
    );
}

const ExpiryAlerts = ({ setActionBar }) => {
    const dispatch=useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const [addEditExpiryAlert, setAddEditExpiryAlert] = useState({ mode: "", modal: false, data: null });
    const [expiryAlertInfo, setExpiryAlertInfo] = useState({ list: [], pagination: null });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: "", type: "" });
    const [sortConfig, setSortConfig] = useState({ field: "", direction: "" });
    const [deleteExpiryAlert, setDeleteExpiryAlert] = useState({ modal: false, data: null });
    const [uploadFile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const[uploadFileProgressData, setUploadFileProgressData]=useState({});
    const [uploadFileStatus, setUploadFileStatus] = useState({ modal: false, data: null, mode: "" });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({});
    const existingExpDate = (expiryAlertInfo?.list?.length && expiryAlertInfo?.list?.map(item => ({
        field_name: item?.module_fields?.field_name,
        key: item?.module?.key
      }))) || [];

    useEffect(() => {
         const uploadedFileData = getApiResponse("expiry_alert", slug);
        getExpiryAlertNotification("skeletonLoader", { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Expiry Alerts' })
                setUploadFileProgressData({uploadedFileData});
    }, []);

    useEffect(() => {
        if (!setActionBar) return;
        setActionBar(
            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px' }}>
                <li className='lease-mobile-button revision-history'>
                    <ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } }); handleItemClicked('Global Revision HistoryIcon'); }} />
                </li>
                {bulk?.type && bulk?.ids?.length ? <>
                    <li className='lease-mobile-button'>
                        <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button'); }}>Cancel</Button>
                    </li>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['D'] }}>
                        <li className='lease-mobile-button'>
                            <Button variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057" }} onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button'); }}>{`Delete (${bulk?.ids?.length})`}</Button>
                        </li>
                    </PermissionWrapper>
                </> : null}
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['C'] }}>
                    <li className='lease-mobile-button'>
                        <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon'  color='primary' variant='contained' size='small' onClick={() => { setAddEditExpiryAlert({ modal: true, mode: 'add', data: { sparta_users: [], non_sparta_users: [], existingExpDate } }); handleItemClicked('Add Item Button'); }}>Add Expiry Alert</Button>
                    </li>
                </PermissionWrapper>
            </ul>
        );
    }, [bulk, setActionBar]);
    const getExpiryAlertNotification = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getExpiryAlertApi(params, query), {})
            .then(response => {
                if (checkApiStatus(response)) {
                    setExpiryAlertInfo(response?.data?.data || { list: [], pagination: null });
                }
                loaderType === "skeletonLoader" ? setSkeletonLoader(false) : setLoading(false);
            })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"expiry_alert"}))
    }

    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === "bulk") {
                setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
        } catch (error) {
            console.error("Error fetching Data!", error);
        }
    }

    const onRequestSort = (event, property) => {
        const isAscending = sortConfig.field === property && sortConfig.direction === "asc";
        const newDirection = isAscending ? "desc" : "asc";
        setSortConfig({ field: property, direction: newDirection });
        getExpiryAlertNotification('fetch', {
            page: expiryAlertInfo?.pagination?.current_page || 1,
            per_page: expiryAlertInfo?.pagination?.per_page || 10,
            sort: newDirection,
            sort_by: property,
        });
    };

    const handeDeletelExpiryAlert = async () => {
        setLoading(true);
        const idsToDelete = deleteExpiryAlert?.modal && deleteExpiryAlert?.data?.id ? [deleteExpiryAlert?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        try {
            await globalDeleteService(deleteExpiryAlertApi(leaseSlug),{ ids: idsToDelete });
            enqueueSnackbar("Expiry alert deleted successfully", { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
            trackActivity('Item Deleted', { page_title: `Delete Expiry Alert`, success_msg: 'Deleted Successfully', item_ids: deleteExpiryAlert?.data || bulk?.ids, response: 'Deleted Successfully' })
            setDeleteExpiryAlert({ modal: false, data: null });
            setBulk({ modal: false, ids: [], type: "", title: "" });
            getExpiryAlertNotification("fetch", { per_page: expiryAlertInfo?.pagination?.per_page || 50 });
        } catch (error) {
            enqueueSnackbar("Delete failed", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
            trackActivity('Item Deleted', { page_title: `Delete Expiry Alert`, error_msg: 'Delete failed', item_ids: deleteExpiryAlert?.data || bulk?.ids, response: 'Delete failed' })
        }
        // setLoading(false);
    };

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "expiry_alert",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar("Attachment(s) uploaded successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getExpiryAlertNotification("", { per_page: expiryAlertInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    };


    const handelAttchments = (attachslug) => {
        setUploadfile({
            ...uploadFile, data: { ...uploadFile.data, attachments: uploadFile.data.attachments.filter(item => item.slug !== attachslug) }
        });
        getExpiryAlertNotification("", { per_page: expiryAlertInfo?.pagination?.per_page || 50 });
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Expiry Alerts`, page_type: page_type, })
    }

    return (
        <>
            <Paper elevation={0}>
                <div style={{ padding: '5px 0px' }}>
                    {
                        skeletonLoader ? <STableLoader count={4} rowCount={11} /> :
                            <>
                                <Paper className='notification-container'  sx={{ overflow: 'auto', boxSizing: 'border-box', ...(expiryAlertInfo?.list?.length > 0
                                    ? { height: 'calc(100vh - 290px) !important' }
                                    : { height: 'auto !important', maxHeight: 'calc(100vh - 290px) !important' }
                                ) }}>
                                    <Table className='mui-table-format' stickyHeader>
                                        <TableHead>
                                            <ExpiryAlertHD
                                                item={expiryAlertInfo?.list}
                                                bulk={bulk}
                                                onRequestSort={onRequestSort}
                                                sortConfig={sortConfig}
                                                toggleBulkOps={toggleBulkOps}
                                                handleItemClicked={handleItemClicked} />
                                        </TableHead>
                                        <TableBody>
                                            {
                                                expiryAlertInfo?.list?.length > 0 && expiryAlertInfo?.list?.map((item, index) => {
                                                    return (
                                                        <ExpiryAlertList
                                                            item={item}
                                                            key={index}
                                                            onView={() => setAddEditExpiryAlert({ modal: true, mode: "view", data: item })}
                                                            onEdit={() => setAddEditExpiryAlert({ modal: true, mode: 'edit', data: { ...item, existingExpDate } }) }
                                                            onDelete={() => { setDeleteExpiryAlert({ modal: true, data: item }); setBulk({ modal: false, ids: [item], title: '', type: '' }); }}
                                                            toggleBulkOps={toggleBulkOps}
                                                            bulk={bulk}
                                                            slug={slug?.slug}
                                                            onOpenAttachments={() => setUploadfile({ modal: true, data: addEditExpiryAlert?.data, mode:'view' })}
                                                            uploadFileProgressData={uploadFileProgressData}
                                                            viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                            viewFile={() => setUploadfile({ modal: true, mode: 'file', data: item })}
                                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        />
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </Paper>
                                {expiryAlertInfo?.list?.length === 0 && <NoRecordFound />}
                                <Paper>
                                    <Pagination
                                        pagination={expiryAlertInfo?.pagination}
                                        onRowsPerPageChange={(e) => getExpiryAlertNotification("", { page: 1, per_page: e.target.value, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })}
                                        onPageChange={(event, newPage) => getExpiryAlertNotification("", { page: newPage + 1, per_page: expiryAlertInfo?.pagination?.per_page, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })} />
                                </Paper>
                            </>

                    }
                </div>
            </Paper>

            {loading ? <PageLoader /> : null}

            {addEditExpiryAlert.mode ?
                <ExpiryAlertCRU
                    params={params}
                    modeType={addEditExpiryAlert?.mode}
                    addEditExpiryAlert={addEditExpiryAlert}
                    onToggleModal={() => setAddEditExpiryAlert({ modal: false, data: null, mode: '' })}
                    getResponseBack={() => {getExpiryAlertNotification('pageLoader', {
                        page: expiryAlertInfo?.pagination?.page || 1,
                        per_page: expiryAlertInfo?.pagination?.per_page || 10
                    }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    fileUpload={handleUpload}
                    onOpenAttachments={() => setUploadfile({ modal: true, data: addEditExpiryAlert?.data, mode:'view' })}
                /> : null
            }

            {deleteExpiryAlert?.modal ?
                <DeletePopUp
                    modal={deleteExpiryAlert.modal}
                    title="Delete Expiry Alert"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => { setDeleteExpiryAlert({ modal: false, data: null }); setBulk({ modal: false, ids: [], title: '', type: '' }); }}
                    onDeleteRecords={() => handeDeletelExpiryAlert()} /> : null
            }

            {
                bulk.modal ? <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length === (expiryAlertInfo?.list?.length || 0) ? "All Expiry Alerts" : "Selected Expiry Alerts"}`}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                    onDeleteRecords={() => handeDeletelExpiryAlert()}
                /> : null
            }

            {
                uploadFile.modal ? <ShowAttachments
                    url="delete-attachment"
                    moduleName="Custom Alert Notification"
                    attachmentsData={uploadFile}
                    getResponseBack={handelAttchments}
                    toggleModalFn={() => setUploadfile({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditExpiryAlert?.mode === 'view' || uploadFile?.mode === 'view'}
                    permissionKey='expiry_alert'
                /> : null
            }

            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />

            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"expiry_alert"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
        </>
    )
}
export default RoleBaseAccess(ExpiryAlerts, { application: 'lease_revamp', feature: 'expiry_alert', operationType: ['R'] });
